export default class SessionStorage {
  static set(key: string, value: any): void {
    try {
      sessionStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
      window["top"]?.postMessage(
        {
          action: "session_storage_set",
          key,
          value,
        },
        "*"
      );
    }
  }

  static remove(key: string): void {
    try {
      sessionStorage.removeItem(key);
    } catch (e) {
      window["top"]?.postMessage(
        {
          action: "session_storage_remove",
          key,
        },
        "*"
      );
    }
  }

  // if you are using a get with cross domain, you will need to add a window event listener on 'message'
  static get(key: string): any {
    try {
      const data = sessionStorage.getItem(key);
      return !!data ? JSON.parse(data) : "";
    } catch (e) {
      window["top"]?.postMessage(
        {
          action: "session_storage_get",
          key,
        },
        "*"
      );
    }

    return null;
  }

  // use with caution
  static clear(): void {
    try {
      sessionStorage.clear();
    } catch (e) {
      window["top"]?.postMessage(
        {
          action: "session_storage_clear",
        },
        "*"
      );
    }
  }

  static clearSpecific(keyChoice: (key: string) => boolean): void {
    try {
      Object.keys(sessionStorage).forEach(
        key => keyChoice(key) && sessionStorage.removeItem(key)
      );
    } catch (e) {
      window["top"]?.postMessage(
        {
          action: "session_storage_clearSpecific",
          keyChoice: keyChoice,
        },
        "*"
      );
    }
  }
}
